export function groupEvents(events = []) {
  const grouped = {};

  for (const event of events) {

    // Prefer operational artifact id
    const key =
        event.artifact_id ||
        event.event_id ||
        event.payload?.artifact_id ||
        // fallback grouping
        event.transcript ||
        event.payload?.transcript ||
        // absolute fallback
        JSON.stringify(event).slice(0, 100);


    if (!grouped[key]) {
      grouped[key] = {
        ...event,
        complianceSignals: [],
        clauses: [],
        riskLevels: new Set(),
        evidence: [],
      };
    }

    console.log("GROUP EVENT:", event);

    // Add signal
    grouped[key].complianceSignals.push({
        clause: event.clause,
        title: event.clause?.title,
        gaps: event.gaps || [],
        severity:
            event.gaps?.[0]?.severity || "medium",
        recommendation:
            event.suggested_actions?.[0] || null,
        });

    // Clause tracking
    if (event.clause?.clause_id) {
      grouped[key].clauses.push(event.clause.clause_id);
    }

    // Risk levels
    if (event.severity) {
      grouped[key].riskLevels.add(event.severity);
    }

    // Evidence
    if (event.payload?.evidenceImages) {
      grouped[key].evidence.push(...event.payload.evidenceImages);
    }
  }

  return Object.values(grouped).map((event) => ({
    ...event,
    clauses: [...new Set(event.clauses)],
    evidence: [...new Set(event.evidence)],
    riskLevels: [...event.riskLevels],
    complianceSignals: event.complianceSignals,
  }));
}